import sum from 'lodash/sum';
import { useCallback, useEffect } from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { inputBaseClasses } from '@mui/material/InputBase';
import InputAdornment from '@mui/material/InputAdornment';
// utils
import { fCurrency } from 'src/utils/format-number';
// _mock
import { _roles, INVOICE_SERVICE_OPTIONS, JOB_SKILL_OPTIONS } from 'src/_mock';

// components
import Iconify from 'src/components/iconify';
import { RHFAutocomplete, RHFSelect, RHFTextField } from 'src/components/hook-form';
import { Checkbox, Chip, FormControl, InputLabel, OutlinedInput, Select } from '@mui/material';

// ----------------------------------------------------------------------

export default function CreateEditSmallTools() {
  const { control, setValue, watch, resetField } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'items',
  });

  const values = watch();

  const totalOnRow = values.items.map((item) => item.quantity * item.price);

  const subTotal = sum(totalOnRow);

  const totalAmount = subTotal - values.discount - values.shipping + values.taxes;

  useEffect(() => {
    setValue('totalAmount', totalAmount);
  }, [setValue, totalAmount]);

  const handleAdd = () => {
    append({
      title: '',
      description: '',
      service: '',
      quantity: 1,
      price: 0,
      total: 0,
    });
  };

  const handleRemove = (index) => {
    remove(index);
  };

  const handleChangeQuantity = useCallback(
    (event, index) => {
      setValue(`items[${index}].quantity`, Number(event.target.value));
      setValue(
        `items[${index}].total`,
        values.items.map((item) => item.quantity * item.price)[index]
      );
    },
    [setValue, values.items]
  );

  const handleChangePrice = useCallback(
    (event, index) => {
      setValue(`items[${index}].price`, Number(event.target.value));
      setValue(
        `items[${index}].total`,
        values.items.map((item) => item.quantity * item.price)[index]
      );
    },
    [setValue, values.items]
  );
  const handleFilterEmployee = useCallback(
    (event, index) => {
      console.log(
        typeof event.target.value === 'string' ? event.target.value.split(',') : event.target.value,
        'what happening'
      );
      setValue(
        `items[${index}].name`,
        typeof event.target.value === 'string' ? event.target.value.split(',') : event.target.value
      );
    },
    [setValue, values.items]
  );
  return (
    <Box sx={{ pt: 3 }}>
      <Stack divider={<Divider flexItem sx={{ borderStyle: 'dashed' }} />} spacing={3}>
        {fields.map((item, index) => (
          <Stack key={item.id} alignItems="flex-end" spacing={1.5}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ width: 1 }}>
              {/* <RHFTextField
                size="small"
                name={`items[${index}].title`}
                label="Title"
                InputLabelProps={{ shrink: true }}
              /> */}

        
              <RHFTextField
                size="small"
                type="number"
                name={`items[${index}].name`}
                label="Name"
                placeholder=""
                InputLabelProps={{ shrink: true }}
              />
                <RHFTextField
                size="small"
                type="number"
                name={`items[${index}].qty`}
                label="Qty"
                placeholder="0"
                InputLabelProps={{ shrink: true }}
              />
              <RHFTextField
                size="small"
                type="number"
                name={`items[${index}].unit`}
                label="Unit"
                placeholder=""
                InputLabelProps={{ shrink: true }}
              />
              <RHFTextField
                size="small"
                type="number"
                name={`items[${index}].unitPrice`}
                label="Unit Price"
                placeholder="0"
                InputLabelProps={{ shrink: true }}
              />
            
            <RHFSelect
                name={`items[${index}].availablity`}
                size="small"
                label="Availablity"
                InputLabelProps={{ shrink: true }}
              >
                {INVOICE_SERVICE_OPTIONS.map((service) => (
                  <MenuItem key={service.id} value={service.name}>
                    {service.name}
                  </MenuItem>
                ))}
              </RHFSelect>
              <RHFSelect
                name={`items[${index}].locationType`}
                size="small"
                label="Location Type"
                InputLabelProps={{ shrink: true }}
              >
                {INVOICE_SERVICE_OPTIONS.map((service) => (
                  <MenuItem key={service.id} value={service.name}>
                    {service.name}
                  </MenuItem>
                ))}
              </RHFSelect>

              <RHFTextField
              disabled
                size="small"
                type="number"
                name={`items[${index}].location`}
                label="Location"
                placeholder=""
                InputLabelProps={{ shrink: true }}
                // sx={{ maxWidth: { md: 116 } }}
              />
              <RHFTextField
              disabled
                size="small"
                type="number"
                name={`items[${index}].amount`}
                label="Amount"
                placeholder="0"
                InputLabelProps={{ shrink: true }}
                sx={{ maxWidth: { md: 116 } }}
              />
            </Stack>
            <Box display="flex" gap="30px">
              {fields.length - 1 == index && (
                <Button
                  size="small"
                  color="primary"
                  startIcon={<Iconify icon="mingcute:add-line" />}
                  onClick={handleAdd}
                  sx={{ flexShrink: 0 }}
                >
                  Add Item
                </Button>
              )}
              <Button
                size="small"
                color="error"
                startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                onClick={() => handleRemove(index)}
              >
                Remove
              </Button>
            </Box>
          </Stack>
        ))}
      </Stack>

      <Divider sx={{ my: 3, borderStyle: 'dashed' }} />
    </Box>
  );
}
